<ng-container *transloco="let t; read: 'layout.navigation'">
  <section class="container">
    @for (branch of navigationTree; track $index) {
      <article class="branch">
        <mat-nav-list dense>
          @for (item of branch; track item.label) {
            @if (item.onMenu && !item.children) {
              <menu-list-item [isChild]="false" [item]="item"></menu-list-item>
            }
            @if (item.onMenu && item.children) {
              <menu-list-container [item]="item"></menu-list-container>
            }
          }
        </mat-nav-list>
      </article>
    }
  </section>
</ng-container>

